import Modal from "../layout/Modal";
import Button from "../layout/Button";

// Substitui window.confirm (mesmo motivo/padrão de LeaveGroupConfirmModal)
// — apagar é irreversível e chega no aparelho do contato de verdade
// (mesmo modelo do "Apagar para todos" do WhatsApp), então merece
// confirmação em vez de sumir no primeiro clique. Compartilhado entre 1:1
// e grupo — conteúdo genérico o bastante pros dois.
function DeleteMessageConfirmModal(props: {
  onClose: () => void;
  onConfirm: () => void;
  deleting?: boolean;
}) {
  return (
    <Modal
      shown
      title="Apagar mensagem"
      onClose={props.deleting ? () => {} : props.onClose}
      className="w-[380px]"
    >
      <p className="text-xs text-primary">
        Apagar essa mensagem para todos? Ela some do WhatsApp de quem recebeu também — não tem
        como desfazer.
      </p>

      <div className="flex justify-end gap-2.5 mt-6">
        <Button outline color="gray" onClick={props.onClose} disabled={props.deleting}>
          Cancelar
        </Button>
        <Button color="red" onClick={props.onConfirm} isLoading={props.deleting}>
          Apagar
        </Button>
      </div>
    </Modal>
  );
}

export default DeleteMessageConfirmModal;
